module.exports = __webpack_public_path__ + "static/img/logo_main.71b362b9.png";